import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MerchantWalletDashboard from './pages/MerchantWalletDashboard/MerchantWalletDashboard.tsx';
import TransactionsPage from './pages/TransactionsPage/TransactionsPage.tsx';
import PartnersPage from './pages/PartnersPage/PartnersPage.tsx';
import PartnerDetailsPage from './pages/PartnersPage/PartnerDetailsPage.tsx';
import ReportsPage from './pages/ReportsPage/ReportsPage.tsx';
import RiskManagementPage from './pages/RiskManagementPage/RiskManagementPage.tsx';
import CollectionsPage from './pages/CollectionsPage/CollectionsPage.tsx';
import PayoutsPage from './pages/PayoutsPage/PayoutsPage.tsx';
import BNPLWalletPage from './pages/WalletsPages/BNPLWalletPage.tsx';
import AcquiringWalletPage from './pages/WalletsPages/AcquiringWalletPage.tsx';
import AdsPrepaidWalletPage from './pages/WalletsPages/AdsPrepaidWalletPage.tsx';
import AdsPostpaidWalletPage from './pages/WalletsPages/AdsPostpaidWalletPage.tsx';
import CreditWalletPage from './pages/WalletsPages/CreditWalletPage.tsx';
import TabbycardWalletPage from './pages/WalletsPages/TabbycardWalletPage.tsx';

const PASSWORD = 'tabby25';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');

  useEffect(() => {
    const sessionAuth = sessionStorage.getItem('isAuthenticated');
    if (sessionAuth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handlePasswordSubmit = (event) => {
    event.preventDefault();
    if (password === PASSWORD) {
      setIsAuthenticated(true);
      sessionStorage.setItem('isAuthenticated', 'true');
    } else {
      alert('Incorrect password');
      setPassword('');
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="password-prompt">
        <h2>Enter Password</h2>
        <form onSubmit={handlePasswordSubmit}>
          <input
            type="password"
            value={password}
            onChange={handlePasswordChange}
            placeholder="Password"
          />
          <button type="submit">Submit</button>
        </form>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<MerchantWalletDashboard />} />
        <Route path="/transactions" element={<TransactionsPage />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/partners/:partnerId" element={<PartnerDetailsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/risk-management" element={<RiskManagementPage />} />
        <Route path="/collections" element={<CollectionsPage />} />
        <Route path="/payouts" element={<PayoutsPage />} />
        <Route path="/wallets/bnpl" element={<BNPLWalletPage />} />
        <Route path="/wallets/acquiring" element={<AcquiringWalletPage />} />
        <Route path="/wallets/ads-prepaid" element={<AdsPrepaidWalletPage />} />
        <Route path="/wallets/ads-postpaid" element={<AdsPostpaidWalletPage />} />
        <Route path="/wallets/credit" element={<CreditWalletPage />} />
        <Route path="/wallets/tabbycard" element={<TabbycardWalletPage />} />
      </Routes>
    </Router>
  );
}

export default App;
